import TerName from "./TerName";
import WarningIconAlert from "../../components/WarningIconAlert";

export default function ItemHeader({
  id,
  name,
  descrip,
  onClick,
  setSelectedTer,
  setOpen,
}) {
  return (
    <div>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
        }}
      >
        <TerName
          id={id}
          title={name}
          onClick={() => onClick(id, name, descrip)}
        />
        {descrip && (
          <div style={{ width: 36, height: 10 }}>
            <WarningIconAlert
              text={descrip}
              onClick={() => {
                setSelectedTer({ descrip });
                setOpen("openWarning");
              }}
            />
          </div>
        )}
      </div>
    </div>
  );
}
